import React, { useEffect, useState } from 'react';
import { api } from '@/api/client';
export default function Mensile(){
  const [dateISO,setDateISO]=useState(()=>new Date().toISOString().slice(0,10));
  const [resume,setResume]=useState<any|null>(null);
  const [details,setDetails]=useState<any[]>([]);
  useEffect(()=>{ Promise.all([
    api.get('/MonthlyBills/GetResume',{ params:{ ADATE: dateISO, DECIMAL_FORMAT: 0 }}),
    api.get('/MonthlyBills/GetDetails',{ params:{ ADATE: dateISO, DECIMAL_FORMAT: 0 }})
  ]).then(([r,d])=>{ setResume(r.data?.Resume?.[0]||null); setDetails(d.data?.MonthDetails||[]); }); },[dateISO]);
  return (<div><h2>Conteggio Mensile</h2><input type="date" value={dateISO} onChange={(e)=>setDateISO(e.target.value)} />{resume && <div>Ore lavorate: {resume.workedhours}</div>}{details.map((x,i)=>(<div key={i}>{x.date} — {x.worktime}</div>))}</div>);
}
